import { NgModule } from '@angular/core';
import { InfoModule } from '../info/info.module';
import { CardBasicComponent } from './card-basic/card-basic.component';
import { CardPackageComponent } from './card-package/card-package.component';
import { CardResponsiveSliderComponent } from './card-responsive-slider/card-responsive-slider.component';
import { CardSliderComponent } from './card-slider/card-slider.component';
import { CardTopicCardComponent } from './card-topic-card/card-topic-card.component';
import { CardTopicComponent } from './card-topic/card-topic.component';
import { CardWideComponent } from './card-wide/card-wide.component';
import { SharedModule } from '../shared/shared.module';
import { UsersFeedbackComponent } from '../price/standalone-components/users-feedback/users-feedback.component';

@NgModule({
	declarations: [
		CardBasicComponent,
		CardPackageComponent,
		CardResponsiveSliderComponent,
		CardSliderComponent,
		CardTopicComponent,
		CardTopicCardComponent,
		CardWideComponent
	],
	imports: [
		SharedModule,
		InfoModule,
		UsersFeedbackComponent,
	],
	exports: [
		CardBasicComponent,
		CardPackageComponent,
		CardResponsiveSliderComponent,
		CardSliderComponent,
		CardTopicComponent,
		CardTopicCardComponent,
		CardWideComponent,
	]
})
export class CardModule { }
